export default "__VITE_ASSET__aa91b8da__"